<template>
<div class="shopApply">
  <div class="title">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: '/home/shopManage' }">店铺管理</el-breadcrumb-item>
      <el-breadcrumb-item>店铺申请</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="main" v-loading="mainLoad">
    <el-card>
      <h3>店铺申请</h3>
      <div class="auth">
        <div class="success bok" v-show="auth_status == 1">
          <div class="left">
            <div class="img">
              <img src="@/assets/icon/icon_shhetguo_01.png" alt="" />
            </div>
            <div class="word">
              <div class="til">
                <p>待审核状态</p>
                <span class="date">提交时间 {{ audit_apply_time }}</span>
              </div>
              <p>平台工作人员将在1~3个工作审批，请及时查看结果~</p>
            </div>
          </div>
          <div class="right">
            <el-steps align-center :active="1" finish-status="success">
              <el-step title="提交申请"></el-step>
              <el-step title="店铺审核"></el-step>
              <el-step title="类目审核"></el-step>
            </el-steps>
          </div>
        </div>
        <div class="pay bok" v-show="auth_status == 2">
          <div class="left">
            <div class="img">
              <img src="@/assets/icon/icon_shhetguo_03.png" alt="" />
            </div>
            <div class="word">
              <div class="til">
                <p>审核通过</p>
                <span class="date">提交时间 {{ audit_apply_time }} &nbsp;&nbsp;&nbsp;&nbsp; 审核时间 {{ audit_time }}</span>
              </div>
              <p>请在72小时内支付，超时未支付，将取消店铺资格，需要重新申请</p>
            </div>
          </div>
          <div class="right">
            <div v-if="!isExpired">
              <p>￥{{ deposit }}</p>
              <!--     <p>￥{{ deposit }}</p> -->
              <el-button @click="toPay" size="small" type="primary">去支付</el-button>
            </div>

          </div>
        </div>
        <div class="err bok" v-show="auth_status == 3">
          <div class="left">
            <div class="img">
              <img src="@/assets/icon/icon_shhetguo_02.png" alt="" />
            </div>
            <div class="word">
              <div class="til">
                <p>审核未通过</p>
                <span class="date">提交时间 {{ audit_apply_time }} &nbsp;&nbsp;&nbsp;&nbsp; 审核时间 {{ audit_time }}</span>
              </div>
              <p>未通过原因：{{ audit_deny_reason }}</p>
            </div>
          </div>
          <div class="right">
            <el-button @click="reEdit" size="small" type="primary">重新编辑</el-button>
          </div>
        </div>
      </div>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="left">
          <div class="subtitle">
            <h4>店铺信息</h4>
          </div>
          <el-form-item label="店铺类型：" prop="type">
            <!--  <el-select v-model="ruleForm.type"

                         class="w400"
                         clearable
                         placeholder="请选择店铺类型">
                <el-option 
                           v-for="(item, index) in type_opt"
                           :value="item.type"
                           :label="item.label"
                           :key="index"></el-option>
              </el-select> -->
            <el-select v-model="ruleForm.type" disabled class="w400" clearable placeholder="请选择店铺类型">
              <el-option :label="item.label" :key='item.type' v-for="item in type_opt" :value="item.type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌授权：" prop="is_auth" required v-if="ruleForm.type == 3 || ruleForm.type == 4">
            <el-radio-group v-model="ruleForm.is_auth" :disabled="is_detail">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商标人名称:" prop="company_name" v-if="this.$route.params.type==3&&ruleForm.is_auth==1">
            <el-input v-model="ruleForm.company_name" placeholder="请输入公司全称" clearable :disabled="is_detail" @blur="getTrademarkInfo" class="w400"></el-input>
          </el-form-item>
          <!-- 添加品牌 -->
          <div class="addBrand" v-if="ruleForm.type == 2 || ruleForm.type == 4">
            <div v-if="ruleForm.is_auth != 2">
              <el-form-item label="品牌信息：" required>
                <el-button type="primary" size="small" @click="addBrand" v-show="!is_detail">添加品牌</el-button>
              </el-form-item>
              <el-table :data="brandList" style="width: 100%; margin-bottom: 22px" border>
                <el-table-column align="center" prop="company_name" label="公司名全称" v-if="this.$route.params.type==4"> </el-table-column>
                <el-table-column align="center" prop="brand_name" label="品牌名称"> </el-table-column>
                <el-table-column align="center" prop="trademark_name" label="商标名称"> </el-table-column>
                <el-table-column align="center" prop="trademark_code" label="注册/申请号"> </el-table-column>
                <el-table-column align="center" prop="valid_end_date" label="到期时间"> </el-table-column>
                <el-table-column align="center" prop="trademark_lce" label="商标证">
                  <template slot-scope="{ row }">
                    <span></span>
                    <el-image style="width: 60px; height: 60px" :src="row.trademark_lce" :preview-src-list="[row.trademark_lce]"> </el-image>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="authorization" label="品牌授权书" v-if="ruleForm.type == 4">
                  <template slot-scope="{ row }">
                    <span></span>
                    <el-image style="width: 60px; height: 60px" :src="row.authorization" :preview-src-list="[row.authorization]"> </el-image>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" v-if="!is_detail">
                  <template slot-scope="scope">
                    <div class="link">
                      <el-link @click="deleteBrand(scope.row)" type="primary">删除</el-link>
                      <el-link @click="editBrand(scope.row, scope.$index)" type="primary">编辑</el-link>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 官方店 -->
          <div v-if="ruleForm.type == 1 || ruleForm.type == 3">
            <div v-if="ruleForm.is_auth != 2">
              <!-- <el-form-item label="公司全称：" prop="trademark_name">
                                    <el-input v-model="ruleForm.trademark_name" placeholder="请输入商标名称" clearable class="w400"></el-input>
                                </el-form-item> -->

              <el-form-item label="品牌名称：" prop="brand_id">
                <el-select v-model="ruleForm.brand_id" class="w400" :disabled="is_detail" filterable remote reserve-keyword placeholder="请输入关键词" @change="changeRemote" :remote-method="remoteMethod" :loading="loading">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="注册/申请号：" prop="trademark_code">
                <!-- <el-input v-model="ruleForm.trademark_code" :disabled="is_detail" @blur="brandBind" placeholder="请输入商标注册/申请号" clearable class="w400"></el-input> -->
                <el-select v-model="ruleForm.trademark_code" class="w400" filterable placeholder="请选择商标" :disabled="is_detail" @change="brandBind">
                  <el-option v-for="item in trademarkList" :key="item.casenum" :label="item.casenum" :value="item.casenum"> </el-option>
                </el-select>

                <!-- <el-select
                                        v-model="ruleForm.trademark_code"
                                        class="w400"
                                        :disabled="is_detail"
                                        filterable
                                        remote
                                        reserve-keyword
                                        placeholder="请输入关键词"
                                        :remote-method="remoteMethod"
                                        :loading="loading"
                                    >
                                        <el-option v-for="item in trademarkList" :key="item.casenum" :label="item.name" :value="item.casenum"> </el-option>
                                    </el-select> -->
              </el-form-item>
              <el-form-item label="商标名称：" prop="trademark_name">
                <el-input v-model="ruleForm.trademark_name" disabled placeholder="请输入商标名称" clearable class="w400"></el-input>
              </el-form-item>
              <el-form-item label="到期时间：" prop="valid_end_date">
                <el-date-picker :disabled="is_detail" v-model="ruleForm.valid_end_date" :picker-options="expireTimeOption" class="w400" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="商标证：" prop="trademark_lce_type">
                <el-radio-group v-model="ruleForm.trademark_lce_type" :disabled="is_detail">
                  <el-radio :label="1">商标证 R</el-radio>
                  <el-radio :label="2">商标证 TM</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="file">
                <!--   :class="ruleForm.file.length>0 ? 'mf' : ''" -->
                <el-upload :disabled="true" action="#" :limit="1" accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF" list-type="picture-card" :auto-upload="false" :file-list="ruleForm.file" :class="{disabled:uploadDisabled}" :on-preview="(file) => handlePreview(file, 0)">
                  <!--     <i slot="default"
                       class="el-icon-plus"></i> -->
                </el-upload>
              </el-form-item>
              <el-form-item prop="file" label="品牌授权书：" required v-if="ruleForm.type == 3">
                <el-upload :disabled="is_detail" action="#" accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF" list-type="picture-card" :auto-upload="false" :class="{disabled:uploadDisabled1}" :file-list="ruleForm.authorization_file" :on-change="(file, fileList) => handleChange(file, fileList, 2)" :on-remove="(file, fileList) => handleRemove(file, fileList, 2)" :on-preview="(file) => handlePreview(file, 0)">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="店铺名称：" prop="name">
            <p v-if="ruleForm.type == 1">{{ ruleForm.name }}<span style="margin-left: 60px; color: #999">系统默认，不可修改</span></p>
            <el-input v-else v-model="ruleForm.name" :disabled="is_detail" placeholder="请输入店铺名称" clearable class="w400"></el-input>
          </el-form-item>
          <div class="subtitle">
            <h4>经营类目</h4>
            <!-- :disabled="classification !==''?false:true"  -->
            <el-button type="primary" size="small" @click="selectCategory" v-show="!is_detail">选择商品名称</el-button>
          </div>
          <div class="table">
            <el-table :data="CategoryData" style="width: 100%" border>
              <el-table-column align="center" prop="id" label="ID"> </el-table-column>
              <el-table-column align="center" prop="name" label="商品库名称"> </el-table-column>
              <el-table-column align="center" label="操作" v-if="!is_detail">
                <template slot-scope="{ row }">
                  <el-link @click="deleteItem(row)" type="primary">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="subtitle">
            <h4>所需资费</h4>
            <p>
              共计 <span>￥{{ deposit }}</span>
            </p>
          </div>
          <div class="tariff">
            <div class="icon-box">
              <div class="item">
                <div class="icon">
                  <span>
                    <i class="iconfont icon-dianpu"></i>
                  </span>
                  <div class="til">
                    <p>店铺使用费</p>
                    <span>￥{{ shop_price }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="subtitle">
            <h4>所需资质</h4>
          </div>
          <div class="table">
            <el-table :data="talentList" style="width: 100%" border v-loading="categoryLoad">
              <el-table-column prop="name" label="资质列表">
                <template slot-scope="{ row }">
                  <p>资质：{{ row.name }}</p>

                  <p style="font-size: 14px; color: red; margin: 8px 0" :style="row.is_must == 1 ? 'color: red' : 'color: blue'">
                    <span v-if="row.is_must == 1">必选资质 </span>
                    <span v-if="row.is_must == 0">选填资质 </span>
                  </p>
                  <el-upload action="#" :disabled="auth_status == 1 || auth_status == 2?true:false" accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF" :auto-upload="false" :file-list="row.file" :limit="1" :show-file-list="true" list-type="picture" :on-preview="(file) => handlePreview(file, 1, row.url)" :on-change="(file, fileList) => handleChange(file, fileList, 1, row.id)" :on-remove="(file, fileList) => handleRemove(file, fileList, 1, row.id)">
                    <el-button size="small" type="primary" :disabled="is_detail">点击上传</el-button>
                  </el-upload>
                </template>
              </el-table-column>
              <el-table-column prop="explain" label="详细说明">
                <template slot-scope="{ row }">
                  <p> {{ row.comment || "-" }}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item style="text-align: right">
            <el-button @click="$router.go(-1)">取 消</el-button>
            <el-button type="primary" @click="onSubmit" :loading="btnloading" v-show="!is_detail">提交审核</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
  <el-dialog :visible.sync="imgDialogVisible" width="500px">
    <img width="100%" :src="imgUrl" alt="" />
  </el-dialog>
  <div v-if="dialogVisible">
    <CategoryDialog ref="refCategoryDialog" :category_options="category_options" @closeModel='initcolse' @selectListFunc="selectListFunc"></CategoryDialog>
  </div>

  <!--  @selectListFunc="selectListFunc" -->
  <BrandDialog ref="refBrandDialog" :type="ruleForm.type" :title="title" @handlePreview="handlePreview" @brandCreate="brandCreate"></BrandDialog>
  <Pay ref="refPay" :shop_id="$route.params.id" :total_amount="deposit" :category_id="ids"></Pay>
</div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex";
import CategoryDialog from "@/components/Modules/ShopManage/CategoryDialog.vue";
import BrandDialog from "@/components/Modules/ShopManage/BrandDialog.vue";
import Pay from "@/components/Modules/ShopManage/Pay.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      btnloading: false,
      uploadDisabled: false,
      uploadDisabled1: false,
      expireTimeOption: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      ruleForm: {
        type: "",
        brand_id: "",
        trademark_name: "",
        trademark_code: "",
        trademark_limit_time: "",
        trademark_lce_type: 1,
        file: [],
        trademark_lce: "",
        name: "",
        authorization: "",
        authorization_file: [],
        is_auth: 1,

      },
      rules: {
        type: [{
          required: true,
          message: "请选择店铺类型",
          trigger: "change"
        }],
        brand_id: [{
          required: true,
          message: "请选择品牌名称",
          trigger: "change"
        }],
        trademark_name: [{
          required: true,
          message: "请输入商标名称",
          trigger: "blur"
        }],
        trademark_code: [{
          required: true,
          message: "请输入商标注册/申请号",
          trigger: "blur"
        }],
        valid_end_date: [{
          required: true,
          message: "请选择到期时间",
          trigger: "change"
        }],
        trademark_lce_type: [{
          required: true,
          message: "请选择商标证",
          trigger: "change"
        }],
        file: [{
          required: true,
          message: "请上传商标",
          trigger: "change"
        }],
        // name: [{ required: true, message: "请输入店铺名称", trigger: "blur" }],
      },
      CategoryData: [], //处理过后的类目列表
      shopType: ["品牌官方店", "品牌旗舰店", "品牌专卖店", "品牌专营店"],
      type_opt: [],
      loading: false,
      options: [
        // {
        //     value: 0,
        //     label: "无",
        // },
      ],
      category_options: [],
      selectList: [], //  选中类目的数组id
      shop_price: "", //店铺金额
      categoryLoad: false,
      category_price: 0, //  类目总金额
      deposit: 0, //店铺+类目总金额
      imgUrl: "", //图片弹窗地址
      imgDialogVisible: false, //查看图片
      ids: [], //分类id字符串
      brandList: [], //品牌列表
      table_index: "", //品牌列表修改索引
      auth_status: 0, //审核状态
      audit_deny_reason: "", //审核拒绝原因
      user_id: "", //商家用户id
      mainLoad: false,
      is_detail: false, //是否允许操作
      audit_time: "", //审核时间
      audit_apply_time: "", //申请时间
      count_down_tile: "00小时 00分钟 00秒", //倒计时
      trademarkList: [],
      isExpired: false,
      timer: null,
      talentList: [],
      title: '',
      pay_amount: '',
      classification: '',
      brand_name: ''
    };
  },
  components: {
    CategoryDialog,
    BrandDialog,
    Pay,
  },
  computed: {
    ...mapGetters(["getToken", "getUserInfo"]),
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("shop"))) {
      this.type_opt = JSON.parse(localStorage.getItem("shop")).type[0];
      console.log(this.type_opt, ' this.type_opt----')
      this.shop_price = sessionStorage.getItem('shopAmount') - 0
      /*  this.shop_price = parseInt(
         this.type_opt.find((item) => {
           return item.type == this.$route.params.type;
         }).amount
       ); */
      this.deposit = ((this.category_price + this.shop_price) - 0).toFixed(2);
      this.type_opt.forEach((item) => {
        item.label = this.shopType[item.type - 1];
      });
    }
  },
  created() {
    this.ruleForm.type = parseInt(this.$route.params.type);
    this.user_id = this.$getSessionStorage("userid");
    if (this.$route.params.id) {
      this.is_detail = true;
      this.uploadDisabled = true
      if (this.is_detail) {
        this.uploadDisabled1 = true
      } else {
        this.uploadDisabled1 = false
      }
      this.getShopDetail();
    }
    if (this.$route.params.type == 1) {
      this.getTrademarkInfo();
    }
    /*  this.getCategoryList(); */

  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapActions({
      storeNameEdit: "detect/storeNameEdit",
      uploadFile: "commodity/uploadFile", //  图片上传
      getListbrand: "commodity/getListbrand", //品牌名称
      getGoodLei: "commodity/getGoodLei", //商品分类
      getKindType: "commodity/getKindType", //商品分类
      categoryManges: "detect/categoryManges", //类别价格-说明
      storeApply: "detect/storeApply", //店铺提交
      applylist: "detect/applylist", //店铺申请详情
      trademarkInfo: "detect/trademarkInfo", //店铺申请详情
      standardTalent: "detect/standardTalent", //资质
    }),
    initcolse() {
      this.dialogVisible = false
    },
    /**@param {详情} */
    // 获取审核资料详情
    getShopDetail() {
      this.mainLoad = true;
      let params = {
        token: this.getToken,
        shop_id: this.$route.params.id,
      };
      this.talentList = []
      this.applylist(params).then(({
        data
      }) => {
        this.mainLoad = false;
        if (data.code == 1) {
          this.pay_amount = data.data.shop[0].amount
          switch (this.ruleForm.type) {
            case 1:
              if (data.data.shop && data.data.shop.length > 0) {
                this.ruleForm.name = data.data.shop[0].name
                var {
                  name,
                  deposit,
                  shop_amount
                } = data.data.shop[0];
              }
              if (data.data.brand && data.data.brand.length > 0) {
                var {
                  brand_name,
                  brand_id,
                  trademark_name,
                  trademark_code,
                  valid_end_date,
                  trademark_lce_type,
                  trademark_lce,
                  authorization,
                } = data.data.brand[0];

              }
              sessionStorage.setItem('classification', data.data.shop[0].classification)
              this.auth_status = data.data.shop[0].audit_status;
              this.audit_time = data.data.shop[0].audit_time;
              this.audit_apply_time = data.data.shop[0].audit_apply_time;
              this.audit_deny_reason = data.data.shop[0].audit_deny_reason;
              this.ruleForm = {
                type: parseInt(this.$route.params.type),
                name,
                shop_amount,
                trademark_name,
                trademark_code,
                valid_end_date,
                trademark_lce_type,
                trademark_lce,
                authorization,
                file: [{
                  url: trademark_lce,
                  name: trademark_lce
                }],
                authorization_file: [{
                  url: authorization,
                  name: authorization
                }],
                brand_id,
              };
              this.deposit = deposit - 0;
              this.options = [{
                label: brand_name,
                value: brand_id,
              }, ];
              this.selectList = [];
              this.CategoryData = data.data.category;
              console.log(this.CategoryData, '详情-----')
              this.talentList = []
              if (data.data.talent && data.data.talent.length > 0) {
                data.data.talent.forEach((item, index) => {
                  this.talentList.push({
                    is_must: item.is_must,
                    comment: item.comment,
                    name: item.talent_name,
                    id: item.id,
                    related_id: item.shop_standard_id,
                    file: [{
                      name: item.talent_name,
                      url: item.image_url
                    }],
                    url: item.image_url,
                  });
                });
              }
              break;
            case 2:
              if (data.data.shop && data.data.shop.length > 0) {
                var {
                  name,
                  deposit,
                  shop_amount
                } = data.data.shop[0];
              }
              if (data.data.brand && data.data.brand.length > 0) {
                data.data.brand.forEach((item) => {
                  var obj = {
                    // company_name: item.company_name,
                    brand_name: item.brand_name,
                    brand_id: item.brand_id,
                    trademark_name: item.trademark_name,
                    trademark_code: item.trademark_code,
                    valid_end_date: item.valid_end_date,
                    trademark_lce_type: item.trademark_lce_type,
                    trademark_lce: item.trademark_lce,
                    authorization: item.authorization,
                  };
                  this.brandList.push(obj);
                });
              }
              sessionStorage.setItem('classification', data.data.shop[0].classification)
              this.auth_status = data.data.shop[0].audit_status;
              this.audit_time = data.data.shop[0].audit_time;
              this.audit_apply_time = data.data.shop[0].audit_apply_time;
              this.audit_deny_reason = data.data.shop[0].audit_deny_reason;
              this.ruleForm = {
                type: parseInt(this.$route.params.type),
                name: name + '品牌旗舰店',
              };
              this.deposit = deposit - 0;
              this.selectList = [];
              this.CategoryData = data.data.category;
              if (data.data.talent && data.data.talent.length > 0) {
                data.data.talent.forEach((item, index) => {
                  this.talentList.push({
                    is_must: item.is_must,
                    comment: item.comment,
                    name: item.talent_name,
                    id: item.id,
                    related_id: item.shop_standard_id,
                    file: [{
                      name: item.talent_name,
                      url: item.image_url
                    }],
                    url: item.image_url,

                  });
                });
              }
              break;
            case 3:
              if (data.data.shop && data.data.shop.length > 0) {
                var {
                  name,
                  deposit,
                  shop_amount
                } = data.data.shop[0];
              }
              if (data.data.brand && data.data.brand.length > 0) {
                var {
                  brand_name,
                  brand_id,
                  is_auth,
                  trademark_name,
                  trademark_code,
                  valid_end_date,
                  trademark_lce_type,
                  trademark_lce,
                  authorization,
                  company_name
                } = data.data.brand[0];
                console.log(data.data.brand[0].trademark_name, '*****')
              }
              this.auth_status = data.data.shop[0].audit_status;
              this.audit_time = data.data.shop[0].audit_time;
              this.audit_apply_time = data.data.shop[0].audit_apply_time;
              this.audit_deny_reason = data.data.shop[0].audit_deny_reason;
              sessionStorage.setItem('classification', data.data.shop[0].classification)
              this.ruleForm = {
                type: parseInt(this.$route.params.type),
                name: name + '品牌专卖店',
                is_auth: data.data.brand[0].is_auth,
                shop_amount,
              };
              if (this.ruleForm.is_auth == 1) {
                this.ruleForm.trademark_code = trademark_code;
                this.ruleForm.brand_id = brand_id;
                this.ruleForm.trademark_name = trademark_name;
                this.ruleForm.valid_end_date = valid_end_date;
                this.ruleForm.trademark_lce_type = trademark_lce_type;
                this.ruleForm.authorization = authorization;
                this.ruleForm.trademark_lce = trademark_lce;

                this.ruleForm.company_name = company_name
                this.ruleForm.file = [{
                  url: trademark_lce,
                  name: trademark_lce
                }];
                this.ruleForm.authorization_file = [{
                  url: authorization,
                  name: authorization
                }];
                this.options = [{
                  label: brand_name,
                  value: brand_id,
                }, ];
              }
              this.deposit = deposit - 0;
              this.selectList = [];
              this.CategoryData = data.data.category;
              if (data.data.talent && data.data.talent.length > 0) {
                data.data.talent.forEach((item, index) => {
                  this.talentList.push({
                    is_must: item.is_must,
                    comment: item.comment,
                    name: item.talent_name,
                    id: item.id,
                    related_id: item.shop_standard_id,
                    file: [{
                      name: item.talent_name,
                      url: item.image_url
                    }],
                    url: item.image_url,

                  });
                });
              }

              break;
            case 4:
              if (data.data.shop && data.data.shop.length > 0) {
                var {
                  name,
                  deposit,
                  shop_amount
                } = data.data.shop[0];
              }
              if (data.data.brand && data.data.brand.length > 0) {
                data.data.brand.forEach((item) => {
                  var obj = {
                    company_name: item.company_name,
                    brand_name: item.brand_name,
                    brand_id: item.brand_id,
                    trademark_name: item.trademark_name,
                    trademark_code: item.trademark_code,
                    valid_end_date: item.valid_end_date,
                    trademark_lce_type: item.trademark_lce_type,
                    trademark_lce: item.trademark_lce,
                    authorization: item.authorization,
                  };
                  this.brandList.push(obj);
                });
              }
              sessionStorage.setItem('classification', data.data.shop[0].classification)
              this.auth_status = data.data.shop[0].audit_status;
              this.audit_time = data.data.shop[0].audit_time;
              this.audit_apply_time = data.data.shop[0].audit_apply_time;
              this.audit_deny_reason = data.data.shop[0].audit_deny_reason;
              this.ruleForm = {
                type: parseInt(this.$route.params.type),
                name: name + '品牌专营店',
                is_auth: data.data.brand[0].is_auth,
              };
              this.deposit = deposit - 0;
              this.selectList = [];
              this.CategoryData = data.data.category;
              if (data.data.talent && data.data.talent.length > 0) {
                data.data.talent.forEach((item, index) => {
                  this.talentList.push({
                    is_must: item.is_must,
                    comment: item.comment,
                    name: item.talent_name,
                    id: item.id,
                    related_id: item.shop_standard_id,
                    file: [{
                      name: item.talent_name,
                      url: item.image_url
                    }],
                    url: item.image_url,

                  });
                });
              }
              break;

            default:
              break;
          }
          /*  this.category_price = 0;
           this.CategoryData.forEach((item) => {
             this.category_price += Number(item.deposit);
           })

           let arrid =[]
           this.deposit = this.category_price - 0 + this.shop_price - 0;
           this.deposit = this.deposit.toFixed(2)
           this.getSpanArr(this.CategoryData, ["one"]);
           this.CategoryData.forEach((item, index) => {
             if (item.three_id) {
                arrid.push(item.three_id);
             }

           });
            this.ids= arrid.join(',') */
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    /**@param {详情} */
    brandBind() {
      this.classification = ''
      this.uploadDisabled = true
      if (this.trademarkList.length == 0) return;
      let obj = this.trademarkList.find((item) => {
        return this.ruleForm.trademark_code == item.casenum;
      });
      this.trademarkList.find((item) => {
        if (this.ruleForm.trademark_code == item.casenum) {
          this.classification = item.classification;
          sessionStorage.setItem('classification', this.classification)
        }

      });
      if (obj) {
        this.ruleForm.trademark_name = obj.brandmame;
        /*   this.ruleForm.valid_end_date = obj.validity; */
        this.ruleForm.trademark_lce = obj.tradeimg;
        this.ruleForm.file = [{
          url: obj.tradeimg,
          name: obj.tradeimg
        }];
        this.getKindType_()
      } else {
        this.$message.warning("未查询到商标信息");
      }

    },
    getTrademarkInfo() {
      let params = {
        token: this.getToken,
      };
      if (this.$route.params.type == 3) {
        params.company_name = this.ruleForm.company_name
      }
      this.trademarkInfo(params).then(({
        data
      }) => {
        if (data.code == 1) {
          if (data.data.message) {
            this.$message.error(data.data.message);
          }
          if (data.data && data.data.zccontent) {
            this.trademarkList = data.data.zccontent.shangbiao;
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    countDown() {
      this.timer = setInterval(() => {
        let t = new Date(this.audit_time).getTime() + 72 * 3600 * 1000;
        let t1 = new Date().getTime();
        let t2 = t - t1;
        if (t2 <= 0) {
          clearInterval(this.timer);
          this.isExpired = true;
        }
        let hh = Math.floor(t2 / (3600 * 1000));
        let mm = t2 % (3600 * 1000);
        let m = Math.floor(mm / (60 * 1000));
        let ss = mm % (60 * 1000);
        let s = Math.floor(ss / 1000);
        this.count_down_tile = `${hh}小时 ${m}分钟 ${s}秒`;
      }, 1000);
    },
    // 支付
    toPay() {
      this.$refs.refPay.shop_name = this.shopType[this.ruleForm.type - 1];
      this.$refs.refPay.type = "shop";
      this.$refs.refPay.dialogVisible = true;
      this.$refs.refPay.onSubmit();
    },
    // 重新编辑
    reEdit() {
      this.is_detail = false;
    },
    // 删除品牌列表
    deleteBrand(row) {
      this.brandList = this.brandList.filter((item) => item.trademark_name != row.trademark_name);
      this.$forceUpdate();
    },
    // 编辑品牌列表
    editBrand(row, index) {
      this.title = '编辑'
      this.table_index = index;
      this.$refs.refBrandDialog.dialogVisible = true;
      this.$refs.refBrandDialog.bindData(JSON.parse(JSON.stringify(row)), "edit");
    },
    // 添加品牌列表
    brandCreate(row, type) {
      if (type == "create") {
        let flag = this.brandList.some((item) => item.trademark_code == row.trademark_code);
        if (flag) {
          this.$message.error('该注册号信息在品牌中不能重复，请重新添加');
          this.$refs.refBrandDialog.dialogVisible = true;
        } else {
          this.$refs.refBrandDialog.dialogVisible = false;
          console.log(row, 'row----row')
          this.brandList.push(row);
        }
      } else {
        Object.assign(this.brandList[this.table_index], row);
      }

      this.$forceUpdate();
    },
    //显示品牌添加弹出
    addBrand() {
      this.title = "添加"
      this.$refs.refBrandDialog.dialogVisible = true;
    },
    // 提交申请
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.btnloading = true
        }
      });
      let {
        type,
        brand_id,
        trademark_name,
        trademark_code,
        valid_end_date,
        trademark_lce_type,
        trademark_lce,
        name,
        is_auth,
        authorization,
        company_name
      } = this.ruleForm;
      let talent_all = [];
      this.CategoryData.forEach(el => {
        this.ids.push(el.id)
      })
      console.log(this.talentList, 'this.talentList')
      this.talentList.forEach((item) => {
        let obj = {
          is_must: item.is_must,
          comment: item.comment,
          name: item.name,
          id: item.id,
          related_id: item.related_id,
          file: [{
            name: item.talent_name,
            url: item.url
          }],
          url: item.url,
        };

        talent_all.push(obj);
      });
      let params;
      console.log(typeof this.ruleForm.type)
      switch (parseInt(this.ruleForm.type)) {
        case 1:
          params = {
            token: this.getToken,
            shop_character: parseInt(this.ruleForm.type), //店铺类型
            name, //店铺名称
            category_id: this.ids.join(','),
            talent_all,
            classification: sessionStorage.getItem('classification'),
            brand_all: [{
              brand_id,
              trademark_name,
              valid_end_date,
              trademark_code,
              trademark_lce_type,
              trademark_lce,
            }, ],
          };

          break;
        case 2:
          params = {
            token: this.getToken,
            shop_character: parseInt(this.ruleForm.type), //店铺类型
            name,
            category_id: this.ids.join(','),
            talent_all,
            classification: sessionStorage.getItem('classification'),
            shop_configure_id: "1",
            deposit: this.deposit,
            shop_amount: this.shop_price,
            brand_all: this.brandList,
          };
          break;
        case 3:
          params = {
            token: this.getToken,
            shop_character: parseInt(this.ruleForm.type), //店铺类型
            user_merchant_id: this.$getSessionStorage("userid"),
            name,

            shop_configure_id: "1",
            deposit: this.deposit,
            shop_amount: this.shop_price,
            category_id: this.ids.join(','),
            talent_all,
            classification: sessionStorage.getItem('classification'),
          };
          if (is_auth == 1) {
            params.brand_all = [{
              is_auth,
              brand_id,
              trademark_name,
              valid_end_date,
              trademark_code,
              trademark_lce_type,
              trademark_lce,
              authorization,
              company_name,
            }, ];
          } else {
            params.brand_all = [{
              is_auth,
            }, ];
          }
          break;
        case 4:
          params = {
            token: this.getToken,
            shop_character: parseInt(this.ruleForm.type), //店铺类型
            user_merchant_id: this.$getSessionStorage("userid"),
            name,
            classification: sessionStorage.getItem('classification'),
            shop_configure_id: "1",
            deposit: this.deposit,
            shop_amount: this.shop_price,
            category_id: this.ids.join(','),
            talent_all,
          };
          if (is_auth == 1) {
            this.brandList.forEach((item) => {
              item.is_auth = 1;
            });
            params.brand_all = this.brandList;
          } else {
            params.brand_all = [{
              is_auth: 2
            }];
          }
          break;
        default:
          break;
      }
      console.log(talent_all, 'talent_all')
      if (talent_all.length > 0) {
        let flag = talent_all.every((item) => {
          return item.is_must == 0
        })
        let flag2 = talent_all.some((item) => {
          return item.is_must == 1 && item.url !== undefined
        })
        if (flag) {
          this.init_subit(params)
        } else {
          if (flag2) {
            this.init_subit(params)
          } else {
            this.btnloading = false
            this.$message.warning(`必传资质类目不能为空！`);
          }
        }
      } else {
        this.init_subit(params)
      }
    },
    /**merchant/store/apply/shop/edit */
    init_subit(params) {

      if (this.is_detail == false && this.auth_status == 3) {
        params.id = this.$route.params.id
        this.storeNameEdit(params).then(data => {
          if (data.data.code == 1) {
            this.btnloading = false
            this.$message.success("提交成功！");
            this.$router.push("/home/shopManage");
          } else {
            this.btnloading = false
            this.$message.error(data.data.msg);
          }
        });
      } else if (this.auth_status == 0) {
        console.log(params, '审核')
        this.storeApply(params).then(({
          data
        }) => {
          if (data.code == 1) {
            this.$message.success("提交成功！");
            this.$router.push("/home/shopManage");
          } else {
            this.btnloading = false
            this.$message.error(data.msg);
          }
        });
      }
    },
    // 文件验证
    isImage(val) {
      let ext = val.split(".").pop().toLowerCase();
      return ext == "jpg" || ext == "png" || ext == "jpeg";
    },
    //查看图片
    handlePreview(file, index, url) {
      switch (index) {
        case 0:
          this.imgUrl = file.url;
          this.imgDialogVisible = true;
          break;
        case 1:
          this.imgUrl = url;
          if (this.isImage(this.imgUrl)) {
            this.imgDialogVisible = true;
          } else {
            window.open(this.imgUrl);
          }
          break;
        case 2:
          this.imgUrl = file.url;
          this.imgDialogVisible = true;
          break;
        default:
          break;
      }
    },
    //商标筛选
    getItem(list, id) {
      if (!list instanceof Array) {
        return null;
      }
      for (let i in list) {
        let item = list[i];
        if (item.id === id) {
          return item.name;
        } else {
          if (item.children) {
            let value = this.getItem(item.children, id);
            if (value) {
              return value;
            }
          }
        }
      }
    },
    //获取商品分类
    getKindType_(classification) {
      this.getKindType({
        token: this.getToken,
        classification: classification
      }).then((res) => {
        if (res.data.code == 1) {
          this.category_options = res.data.data.treeData;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * @param {以下----商品标准库+资质} 
     * @param {selectCategory 获取} 
     * @param {deleteItem 删除} 
     * @param {selectListFunc 选中标准库获取资质} 
     * @param {getstandardTalent 接口获取资质} 
     */
    selectCategory() {
      this.dialogVisible = true
    },
    deleteItem(row) {
      this.CategoryData = this.CategoryData.filter((item) => row != item)
      this.talentList = this.talentList.filter((item) => row.id != item.related_id)
    },
    //选择数据处理
    selectListFunc(val) {
      let obj = {
        id: val.id,
        name: val.value
      }
      let fla1 = this.CategoryData.some(item => item.id == val.id)

      if (fla1) {
        this.$message.error('不能重复选择')
      } else {
        this.CategoryData.push(obj)
        this.getstandardTalent(val)
      }
    },
    getstandardTalent(val) {
      let params = {
        token: this.getToken,
        cate_ids: val.id
      }
      this.standardTalent(params).then(res => {
        if (res.data.code == 1) {
          this.talentList = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /**
     * @param {以上-----商品标准库+资质} 
     */
    bindShopName() {
      if (this.ruleForm.type == 1) this.ruleForm.name = this.brand_name + "品牌官方店";
    },
    //品牌查询
    getSearchData(query) {
      this.getListbrand({
        name: query
      }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.options = res.data.list.map((item) => {
            return {
              value: item.id,
              label: item.name
            };
          });

          // this.options.unshift({
          //     value: 0,
          //     label: "无",
          // });
        }
      });
    },
    changeRemote(val) {
      this.options.find((item) => {
        if (val == item.value) {
          this.brand_name = item.label;
        }
      });
      if (this.brand_name) {
        this.bindShopName()
      }

    },
    //品牌查询
    remoteMethod(query) {

      if (query !== "") {
        this.loading = true;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.getSearchData(query);
        }, 800);
      } else {
        this.options = [
          // {
          //     value: 0,
          //     label: "无",
          // },
        ];
      }
    },

    //文件上传
    handleChange(file, fileList, index, id) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      let i;
      switch (index) {
        case 0:
          this.ruleForm.file = fileList;
          if (this.ruleForm.file.length > 0) {
            this.$refs.ruleForm.clearValidate("file");
          }
          break;
        case 1:
          i = this.talentList.findIndex((item) => {
            console.log(id, item.id)
            return id == item.id;
          });

          this.$set(this.talentList[i], "file", fileList);
          break;
        case 2:
          this.ruleForm.authorization_file = fileList;
          if (this.ruleForm.authorization_file.length > 0) {
            this.$refs.ruleForm.clearValidate("file");
            this.uploadDisabled1 = true
          }
          break;
        default:
          break;
      }
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          this.$message.success("上传成功！");
          switch (index) {
            case 0:
              this.ruleForm.trademark_lce = res.data.formdata_details[0].urls;
              break;
            case 1:
              this.$set(this.talentList[i], "url", res.data.formdata_details[0].urls);
              break;
            case 2:
              this.ruleForm.authorization = res.data.formdata_details[0].urls;
              break;
            default:
              break;
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    //文件删除
    handleRemove(file, fileList, index, talent_id) {
      let i;
      switch (index) {
        case 0:
          this.ruleForm.file = [];
          break;
        case 1:
          i = this.talentList.findIndex((item) => {

            return talent_id == item.id;
          });
          this.$set(this.talentList[i], "file", []);
          break;
        case 2:
          this.ruleForm.authorization_file = [];
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style>
.disabled .el-upload--picture-card {
  display: none !important;
}
</style><style lang="scss" scoped>
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }

  .el-scrollbar:nth-child(2) {
    .el-checkbox {
      display: none;
    }
  }
}

.shopApply {
  .title {
    width: 100%;
    background: #fff;
    padding: 15px 32px;
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);

    p {
      font-size: 20px;
      color: #000000;
      margin-left: 0;
      display: inline-block;
    }

    p.to {
      cursor: pointer;

      &:hover {
        color: #0094ff;
      }
    }
  }

  .main {
    min-width: 1200px;
    padding: 20px;
    overflow: hidden;

    .auth {
      margin: 0 140px 40px;

      .bok {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          .word {
            margin-left: 20px;

            .til {
              display: flex;

              p {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
                line-height: 20px;
              }

              span {
                margin-left: 20px;
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                line-height: 32px;
              }
            }

            &>p {
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              line-height: 32px;
            }
          }

          display: flex;
        }

        .right {
          &>div {
            align-items: center;
            display: flex;

            p {
              font-size: 16px;
              font-weight: bold;
              color: #ea5846;
              line-height: 36px;
              margin-right: 20px;
            }
          }

          &>p {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            margin-top: 6px;
          }
        }
      }
    }

    .form {
      margin: 0 140px;

      .table {
        margin-bottom: 35px;

        ::v-deep .el-table--border th.el-table__cell {
          background-color: #f8f9fe;
        }
      }

      .tariff {
        height:150px;
        overflow-y: auto;
        .icon-box {
          .item {
            margin-bottom: 30px;
            width: 100%;
            padding: 20px;
            background: #ffffff;
            border: 1px solid #dddddd;
            ul {
              margin-top: 20px;

              li {
                list-style: none;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 46px;
                line-height: 46px;
                border-bottom: 1px solid #ddd;
                color: #333;

                &:last-child {
                  border: none;
                }
              }
            }

            .icon {
              display: flex;
              align-items: center;

              &>span {
                margin-right: 24px;
                display: block;
                width: 60px;
                height: 60px;
                border-radius: 50%;
                border: 2px solid #ddd;
                display: flex;
                justify-content: center;
                align-items: center;

                i {
                  font-size: 32px;
                  color: #666;
                }
              }

              .til {
                p {
                  font-size: 16px;
                  font-weight: bold;
                  color: #333333;
                  line-height: 36px;
                }

                span {
                  color: #ea5846;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }

    .el-card {
      h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
        margin-bottom: 20px;
      }
    }

    .subtitle {
      overflow-y: auto;
      margin-bottom: 35px;
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 40px;
      }

      p {
        line-height: 18px;
        margin-left: 40px;

        span {
          margin-left: 14px;
          color: #ea5846;
        }
      }

      h4 {
        padding-left: 20px;
        line-height: 18px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        color: #333333;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 2px;
          background: #2448ff;
        }
      }
    }
  }
}

.w400 {
  width: 400px;
}

.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}

.link {
  a {
    margin: 0 8px;
  }
}

::v-deep .el-steps--horizontal {
  width: 350px;
}

::v-deep .el-radio__input.is-disabled+span.el-radio__label,
::v-deep .el-input.is-disabled .el-input__inner {
  color: #666;
}

::v-deep .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
